import React from 'react';

import ListGroup from '../../Components/ListGroup';
import Heading from '../../Components/Heading';
import ImageBlurFallback from '../../Components/ImageBlurFallback';

import IMAGE_3001_PNG from '../../Assets/v2/ThreeHundred/3001.png';
import IMAGE_3002_PNG from '../../Assets/v2/ThreeHundred/3002.png';
import IMAGE_3003_PNG from '../../Assets/v2/ThreeHundred/3003.png';
import IMAGE_3004_PNG from '../../Assets/v2/ThreeHundred/3004.png';
import IMAGE_3005_PNG from '../../Assets/v2/ThreeHundred/3005.png';

import IMAGE_3001_WEBP from '../../Assets/v2/ThreeHundred/3001.webp';
import IMAGE_3002_WEBP from '../../Assets/v2/ThreeHundred/3002.webp';
import IMAGE_3003_WEBP from '../../Assets/v2/ThreeHundred/3003.webp';
import IMAGE_3004_WEBP from '../../Assets/v2/ThreeHundred/3004.webp';
import IMAGE_3005_WEBP from '../../Assets/v2/ThreeHundred/3005.webp';

import IMAGE_3001_FALLBACK from '../../Assets/fallbacks/ThreeHundred/3001.jpg';
import IMAGE_3002_FALLBACK from '../../Assets/fallbacks/ThreeHundred/3002.jpg';
import IMAGE_3003_FALLBACK from '../../Assets/fallbacks/ThreeHundred/3003.jpg';
import IMAGE_3004_FALLBACK from '../../Assets/fallbacks/ThreeHundred/3004.jpg';
import IMAGE_3005_FALLBACK from '../../Assets/fallbacks/ThreeHundred/3005.jpg';

const ProCard = ({ title, className, fallbackImage, webpImage, image }) => {
  return (
    <div className={`th-pro-card ${className}`}>
      <ImageBlurFallback
        className="th-pro-card-image"
        fallbackImage={fallbackImage}
        src={image}
        webpImage={webpImage}
      />
      <span className="th-pro-card-title">{title}</span>
    </div>
  );
};
const Pro = () => {
  return (
    <ListGroup
      center
      containerClassName="th-pro-container"
      title={<Heading title="GET PRO IN ALL THESE AREAS" />}
      count={3}>
      <ProCard
        title="Following industry standard practices"
        fallbackImage={IMAGE_3003_FALLBACK}
        image={IMAGE_3003_PNG}
        webpImage={IMAGE_3003_WEBP}
      />

      <ProCard
        title="End to end process based mentorship"
        fallbackImage={IMAGE_3004_FALLBACK}
        image={IMAGE_3004_PNG}
        webpImage={IMAGE_3004_WEBP}
      />

      <ProCard
        title="Collaborating and managing projects in team"
        fallbackImage={IMAGE_3005_FALLBACK}
        image={IMAGE_3005_PNG}
        webpImage={IMAGE_3005_WEBP}
      />

      <ProCard
        title="Bug identification and fixing"
        fallbackImage={IMAGE_3001_FALLBACK}
        image={IMAGE_3001_PNG}
        webpImage={IMAGE_3001_WEBP}
      />

      <ProCard
        title="Working on a custom project from scratch"
        fallbackImage={IMAGE_3002_FALLBACK}
        image={IMAGE_3002_PNG}
        webpImage={IMAGE_3002_WEBP}
      />
    </ListGroup>
  );
};

export default Pro;



// WEBPACK FOOTER //
// ./src/Pages/ThreeHundred/Pro.js